import flatten from 'flat';
import { Translations } from 'ilenia';
import * as enUS from './localization/en-US/string.json';
import * as deDE from './localization/de-DE/string.json';

export class Localization {
    public static locales = {
        'en-US': enUS,
        'de-DE': deDE,
    };

    public static allowedLocales = Object.keys(Localization.locales);

    public static getTranslations(locale: string = 'en-US'): Translations {
        if (locale === 'en-US') {
            return flatten(enUS);
        }
        return {
            ...flatten(enUS),
            ...flatten(Localization.locales[locale])
        };
    }
}



// WEBPACK FOOTER //
// ./src/Localization.ts